import { API } from '@/src/api/api'
import { queryKeys } from '@/src/api/queryKeys'
import type { IsoGoalFetchResponseListDto } from '@/src/api/types/generated-types'
import { useLocationsContext } from '@/src/contexts/LocationsContext'
import { ONE_MINUTE_IN_MS } from '@/src/utils/constants'
import { useQuery } from '@tanstack/react-query'

export const useEnergyGoals = () => {
  const { companyPgId } = useLocationsContext()

  const queryKey = queryKeys.iso.goals.manyByCompanyId.toKeyWithArgs(companyPgId)
  const query = useQuery<IsoGoalFetchResponseListDto>({
    queryKey,
    staleTime: ONE_MINUTE_IN_MS * 5,
    gcTime: ONE_MINUTE_IN_MS * 5,
    enabled: !!companyPgId,
    queryFn: async () => {
      // @ts-ignore
      const response = await API.isoGoals.fetch({ companyId: companyPgId })
      return response
    },
  })
  return { ...query, data: query.data }
}
